export const VENDOR_NAME_KEY = 'vendorName';
